import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import EditableCell from "./EditableCell";
import { ReactTable } from "../../../components/DataTable/DataTable";
import { getOrderColumns } from "./columns";

const parseLegsForErrors = legs =>
  legs.map((leg, i) => {
    const updatedLeg = { ...leg };
    const prevLeg = legs.find(l => l.Leg === leg.Leg - 1);

    if (leg.Leg > 1 && i < legs.length - 1 && prevLeg) {
      const prevArrivalDate = moment(prevLeg.ArrivalDate)
        .add(prevLeg.TravelTime + prevLeg.Route.UnloadTime, "hours")
        .valueOf();
      const currPickupDate = moment(leg.PickupDate).valueOf();
      if (prevArrivalDate - currPickupDate > 0) {
        updatedLeg.error = true;
      } else if (prevArrivalDate - currPickupDate < 0) {
        updatedLeg.warning = true;
      } else {
        updatedLeg.success = true;
      }
    }
    return updatedLeg;
  });

const defaultColumn = {
  Cell: EditableCell
};

const getRowStyles = row => {
  const style = {};
  if (row.original.error) {
    style.background = "#e63462";
    style.color = "hsl(0, 0%, 4%)";
  } else if (row.original.warning) {
    style.background = "#f6bd60";
    style.color = "hsl(0, 0%, 4%)";
  } else if (row.original.success) {
    style.background = "#8ed081";
    style.color = "hsl(0, 0%, 4%)";
  }
  return style;
};
const TripLegs = ({ label, linkedLegs, loading }) => {
  const parsedLegs = parseLegsForErrors(linkedLegs);
  const updateData = data => {
    console.log(data);
  };
  return loading ? (
    <div>Loading </div>
  ) : (
    <div>
      <ReactTable
        columns={getOrderColumns(label)}
        data={parsedLegs}
        defaultColumn={defaultColumn}
        displayPaginationControls={false}
        getRowProps={row => ({
          style: getRowStyles(row)
        })}
        sortBy={[{ id: "leg", desc: false }]}
        updateData={updateData}
        onRowClick={({ RecId }) => {
          const el = document.querySelector(`#order-${RecId}`);
          if (el) {
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
          }
        }}
      />
      {/* <pre>
        <code>{JSON.stringify(linkedLegs, null, 2)}</code>
      </pre> */}
    </div>
  );
};

TripLegs.propTypes = {
  label: PropTypes.string,
  linkedLegs: PropTypes.array,
  loading: PropTypes.bool
};
export default TripLegs;
